import { render, staticRenderFns } from "./materialCover.vue?vue&type=template&id=0833a434&scoped=true&"
import script from "./materialCover.vue?vue&type=script&lang=js&"
export * from "./materialCover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0833a434",
  null
  
)

export default component.exports